import { ref} from "vue";

export function useEventEnums() {

    const inscriptionStatus = ref({
        UNVALIDATED: 'UNVALIDATED',
        APPROVED: 'APPROVED',
        REJECTED: 'REJECTED'
    })


    return { inscriptionStatus }
}